// Tripadvisor.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const Tripadvisor = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.tripadvisor.es/Hotel_Review-g580312-d267051-Reviews-Hotel_Condesa-Port_d_Alcudia_Alcudia_Majorca_Balearic_Islands.html?lang=es",
    en: "https://www.tripadvisor.es/Hotel_Review-g580312-d267051-Reviews-Hotel_Condesa-Port_d_Alcudia_Alcudia_Majorca_Balearic_Islands.html?lang=en",
    de: "https://www.tripadvisor.es/Hotel_Review-g580312-d267051-Reviews-Hotel_Condesa-Port_d_Alcudia_Alcudia_Majorca_Balearic_Islands.html?lang=de",
    fr: "https://www.tripadvisor.es/Hotel_Review-g580312-d267051-Reviews-Hotel_Condesa-Port_d_Alcudia_Alcudia_Majorca_Balearic_Islands.html?lang=fr",
    pt: "https://www.tripadvisor.es/Hotel_Review-g580312-d267051-Reviews-Hotel_Condesa-Port_d_Alcudia_Alcudia_Majorca_Balearic_Islands.html?lang=pt",
    nl: "https://www.tripadvisor.es/Hotel_Review-g580312-d267051-Reviews-Hotel_Condesa-Port_d_Alcudia_Alcudia_Majorca_Balearic_Islands.html?lang=nl",
  };

  return (
    <>
      {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
      <button
        className="button-styles hover-text"
        onClick={() => setShowModal(true)}
      >
        <span className="tooltip-text" id="fade">
          Tripadvisor
        </span>
        <i className="fa fa-tripadvisor icon-adjusted" />
      </button>
      {showModal && (
        <LanguageModal
          title="Tripadvisor"
          icon="fa fa-tripadvisor"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Tripadvisor;
